module.exports = __webpack_public_path__ + "static/media/home.52d85cbb.svg";